import { render, staticRenderFns } from "./EmptyColumn.vue?vue&type=template&id=709c01dd&"
import script from "./EmptyColumn.vue?vue&type=script&lang=js&"
export * from "./EmptyColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports